import { IconEye, IconEyeOff } from '@tabler/icons-react'
import clsx from 'clsx'
import { useState } from 'react'

export const PasswordField = ({ field, form }: any) => {
  const [showHidePassword, changeShowHidePassword] = useState(false)
  const hasError = form.touched[field.name] && form.errors[field.name]

  return (
    <div className='input-group input-group-lg'>
      <input
        type={showHidePassword ? 'text' : 'password'}
        {...field}
        className={clsx(
          'form-control form-control-lg form-control-solid',
          hasError ? 'input-error input-field' : 'input-field'
        )}
      />
      <div className='input-group-prepend'>
        <span
          className='input-group-text form-control-lg form-control-solid border-0'
          onClick={() => changeShowHidePassword(!showHidePassword)}
        >
          {showHidePassword ? (
            <IconEyeOff size={18} aria-hidden='true' />
          ) : (
            <IconEye size={18} aria-hidden='true' />
          )}
        </span>
      </div>
    </div>
  )
}
